import styled from "styled-components";

export interface FooterBorderProps {
  borderGradient?: string[];
}

export const FooterSectionContainer = styled.div`
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
`;

export const FooterBorder = styled.div<FooterBorderProps>`
  background: linear-gradient(
    to right,
    ${(props) => props.borderGradient?.join(", ")}
  );
  height: 2px;
`;

export const FooterDescription = styled.div`
  font-size: 12px;
  font-weight: 900;
`;
